import type { FaireProductEntity } from "../../entity_types/product";

export const p_tub8ybxvr8: FaireProductEntity = {
  token: "p_tub8ybxvr8",
  type: "product",
  name: "Lullaby Natural Sleep Gummies",
  brandToken: "b_2jhqmyenj6",
  brandName: "LucidMood",
  imageUrl:
    "https://cdn.faire.com/fastly/3c5b0e3d35dc55e4f7a42936a64a189ff2618dccdbe39ee0e28c7f678deafcb5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/386bd8629c39fd67fd59831769e863261f0665bab292095c2453baa3ad33519b.png",
    "https://cdn.faire.com/fastly/1e8ecfc5a87affb0568c9a7f7606cb514bf94497c415601f52c78edf575515d4.png",
    "https://cdn.faire.com/fastly/5ebe837a1f5d251c6f910d23080184238d6d54730378b07653febc2f8bfbee8d.jpeg",
  ],
  priceDollars: 6.49,
  description:
    "Relaxed & Dreamy\n\nUnwind your day with a moment of recovery and relaxation. These dreamy vegan gummies are your perfect companion for calming your mind before bedtime, helping you drift into a peaceful slumber. Crafted with a soothing blend of goodness, they’re a delightful addition to your nightly routine—whether you’re settling in with a good book, enjoying a warm bath, or simply winding down after a long day.\n\nInfused with Reishi and Ashwagandha to relieve tension and calm the mind, Botanical Terpenes, Valerian Root for relaxation, and a Chamomile Blend for a restful evening.\n\nMixed Berry\n\n15 Gummies per Pouch\n\nDISTRIBUTED BY:\nPalmer Jane, Inc\nVail, Colorado 81657, USA\nwww.lucidmood.co\n",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:17.508Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
